import React from "react";
import "./TheFooter.scss";

const TheFooter = () => {
  return (
    <footer className="footer">
      <div className="container footer__inner">

      </div>
    </footer>
  );
};

export default TheFooter;
